const handleDelete = async (deleteUrl, csrf) => {
    console.log(`${deleteUrl}`)
    try {
      // Make a request to your Rails backend's logout endpoint (adjust URL accordingly)
      const response = await fetch(`/recipes/${deleteUrl}`, {
        method: 'DELETE', // Devise uses a DELETE request for logout
        headers: {
            'X-CSRF-Token': csrf
        }
      });
  
      console.log(`STATUS ` + response.status)

      if (response.ok) {
        // Redirect to the desired page after successful logout
        window.location.href = '/recipes';
      } else {
        // Handle error if logout request fails
        console.error('Delete failed');
      }
    } catch (error) {
      console.error('Error during deletion: ', error);
    }

};

export default handleDelete;